import React, { useState, useEffect } from "react";
import GlobalStudentPersonelQuestionsList from "../../pages/common/globalpersonelquestionlist";
import { useAuth } from "../../../usercontext";
import STopMenu from "../../../components/student/topmenu/topmenu";
import S911TopMenu from "../../student911/topmenu/topmenu";
import PageNotes from '../../pages/common/pagenotesnew'

export default function StudentPersonelQuestionsList() {
	const { profile } = useAuth()

	const slug = profile.id
	console.log('slug: ', slug)
	const isStudent911 = profile?.role === 'Student911'
	return (
		<div>
			{!isStudent911 && <STopMenu slug={slug} activeMenu="PersonelQuestionsList" />}
			{isStudent911 && <S911TopMenu slug={slug} activeMenu="PersonelQuestionsList" />}
			<PageNotes type={'Student'} studentId={slug} />
			<GlobalStudentPersonelQuestionsList slug={slug} />
		</div>
	)
}
